//external
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
//internal
import { deleteScheduleTodo, getScheduleTodo } from 'services/todo/service';
import history from 'services/history';
import { startRequest, finishRequest } from 'store/modules/loading/actions';
import ContentPanel from 'components/ContentPanel';
import { setMessage } from 'store/modules/message/action';
import { sanitizeErrorUI } from 'utils/errorUtil';
//style
import { Attr, AttrName } from './styled';
import { Button, ButtonContainer } from 'styles/components';

export default function TodoDelete({match}) {
  const todoId = match.params.id;
  const message = useSelector(state => state.message.data);
  const [dataTodo, setDataTodo] = useState();

  const dispatch = useDispatch();

  useEffect(() => {
    if (todoId) {
      dispatch(startRequest());
      getScheduleTodo(todoId).then(data => {
        setDataTodo(data.data);
      }).catch(err => {
        dispatch(setMessage(sanitizeErrorUI(err)));
      }).finally(() => {
        dispatch(finishRequest());
      });
    }
  }, [dispatch, todoId]);

  async function handleDelete () {
    dispatch(startRequest());
    deleteScheduleTodo(todoId).then(data => {
      history.push('/schedule/schedule_todo')
    }).catch(err => {
      dispatch(setMessage(sanitizeErrorUI(err)));
    }).finally(() => {
      dispatch(finishRequest());
    });
  }

  async function handleBack () {
    history.goBack();
  }

  return (
    <>
      <ContentPanel title="Deseja excluir esta tarefa?" message={message}>
        {dataTodo && <>
          <AttrName>Assunto:</AttrName>
          <Attr>{dataTodo.subject}</Attr>
          <AttrName>Usuário:</AttrName>
          <Attr>{dataTodo.user}</Attr>
          <AttrName>Status:</AttrName>
          <Attr>{dataTodo.status}</Attr>
          <ButtonContainer>
            <br />
            <Button left={true} cancel={true} onClick={handleBack}>
              Voltar
            </Button>
            <Button onClick={handleDelete}>
              Excluir
            </Button>
          </ButtonContainer>
        </>}
      </ContentPanel>
    </>
  )
}